import _ from 'lodash';
import './giftcard.scss';
import axios from 'axios';
import Alert from '../views/alert';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { BarLoader } from 'react-spinners';
import config from '../../variables/config';
import { sendRequest } from '../../modules/admin';
import generateReference from '../helpers/reference';
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack';
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline';
import { fetchGiftcards, updateGiftcard, setDefaults, createGiftcard } from '../../modules/giftcards';

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => {}
}

const addText = 'Add';
const findText = 'Find';
const cancelText = 'Cancel';
const searchText = 'Search';
const amountText = 'Amount';
const createText = 'Create';
const downloadText = 'Download';
const giftcardText = 'Giftcard';
const subtractText = 'Subtract';
const activateText = 'Activate';
const deactivateText = 'Deactivate';
const moreOptionsText = 'More options';
const changeAmountText = 'Change amount';
const findGiftcardText = 'Find giftcard';
const createGiftcardText = 'New giftcard';
const tryAgainText = 'Please try again later';

class Giftcard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: 0,
      search: '',
      selectedGiftcard: {
        selected: false,
        giftcard: {}
      },
      changeAmount: 0,
      selectedAction: null,
      previewSelected: false,
      changeAmountAction: null,
      alert: _.clone(emptyAlert),
    }
  }

  componentDidMount = () => {
    this.props.sendRequest(fetchGiftcards)
  }

  componentDidUpdate = () => {
    const { giftcards } = this.props;
    const { selectedGiftcard } = this.state;

    if (selectedGiftcard.selected) {
      const found = giftcards.find(giftcard => giftcard.id === selectedGiftcard.giftcard.id);

      if (found && found !== null && !_.isEqual(found, selectedGiftcard.giftcard)) {
        this.setState({
          selectedGiftcard: {
            ...selectedGiftcard,
            giftcard: found
          }
        })
      }
    }
  }

  search = () => {
    const { search } = this.state;
    var items = _.clone(this.props.giftcards);

    var filteredItems = items.filter((item) => {
      const reference = item.reference;

      if (reference.substring(0, search.length).toLowerCase() === search.toLowerCase())
        return true;
      else if (reference.substring(reference.length - search.length, reference.length).toLowerCase() === search.toLowerCase())
        return true;
      else
        return false;
    })

    return filteredItems;
  }

  selectGiftcard = (giftcard) => {
    this.setState({
      selectedGiftcard: {
        selected: true,
        giftcard: giftcard
      }
    })
  }

  unselectGiftcard = () => {
    this.setState({
      previewSelected: false,
      changeAmountAction: null,
      selectedGiftcard: {
        giftcard: {},
        selected: false,
      }
    })
  }

  redirectBack = () => {
    const { unselectGiftcard } = this;
    const { selectedGiftcard, selectedAction } = this.state;

    if (selectedGiftcard.selected) {
      unselectGiftcard()
    } else if (selectedAction === 'find') {
      this.setState({
        search: '',
        selectedAction: null,
      })
    } else if (selectedAction === 'create') {
      this.setState({
        selectedAction: null,
      })
    }
  }

  redirectToNewCard = () => {
    const { newGiftcardId, giftcards } = this.props;

    const found = giftcards.find(giftcard => giftcard.id === newGiftcardId);

    if (found) {
      this.setState({
        amount: 0,
        selectedAction: 'find',
        selectedGiftcard: {
          selected: true,
          giftcard: found
        }
      })
    }
  }

  download = async () => {
    const { selectedGiftcard } = this.state;
    const reference = selectedGiftcard.giftcard.reference;

    const url = config.serverURL + `/Giftcards/preview?reference=${reference}&access_token=` + this.props.token;
    const response = await axios.get(url);
    var a = document.createElement('a');
    a.href = response.data;
    a.download = `giftcard-${reference}.png`;
    a.click();
  }

  create = () => {
    const { sendRequest } = this.props;
    const amount = Number(this.state.amount);

    const data = {
      initAmount: amount,
      remainAmount: amount,
      reference: generateReference('WKGC')
    }

    sendRequest(createGiftcard, data);
  }

  updateAmount = () => {
    const { sendRequest } = this.props;
    const { changeAmountAction, changeAmount, selectedGiftcard } = this.state;
    const giftcard = selectedGiftcard.giftcard

    if (changeAmountAction === 'add') {
      const data = {
        id: giftcard.id,
        properties: {
          remainAmount: Math.round((giftcard.remainAmount + Number(changeAmount)) * 100) / 100
        }
      }
      sendRequest(updateGiftcard, data);
    } else if (changeAmountAction === 'subtract') {
      const data = {
        id: giftcard.id,
        properties: {
          remainAmount: Math.round((giftcard.remainAmount - Number(changeAmount)) * 100) / 100
        }
      }
      sendRequest(updateGiftcard, data);
    } else {
      console.log('giftcard - updateAmount: error action not found');
    }
  }

  changeActivate = () => {
    const { sendRequest } = this.props;
    const { selectedGiftcard } = this.state;

    const data = {
      id: selectedGiftcard.giftcard.id,
      properties: {
        isActive: !selectedGiftcard.giftcard.isActive
      }
    }
    sendRequest(updateGiftcard, data);
  }

  checkForAlert = () => {
    const { redirectToNewCard } = this;
    const { requestFailed, requestFinished, sendRequest, newGiftcardId } = this.props;

    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert}/>
    } else if (requestFailed) {
      var alert = _.clone(emptyAlert);
      alert.type = 'error';
      alert.showAlert = true;
      alert.message = tryAgainText;
      alert.callback = () => {
        sendRequest(setDefaults)
        this.animateClose();
      }

      return <Alert alert={alert}/>
    } else if (requestFinished) {
      var alert2 = _.clone(emptyAlert);
      alert2.type = 'success';
      alert2.showAlert = true;
      alert2.callback = () => {
        if (newGiftcardId && newGiftcardId !== null) {
          redirectToNewCard();
        }
        sendRequest(setDefaults)
      }

      return <Alert alert={alert2}/>
    } else {
      return void(0)
    }
  }

  getLoadingView = (view) => {
    const { requestLoading } = this.props;

    if (requestLoading) {
      return (
        <BarLoader
          size={150}
          color={'#fff'}
          sizeUnit={"px"}
          css={{ margin: 'auto', marginTop: 18, marginBottom: 18 }}
          loading={this.state.loading}
        />
      )
    } else {
      return view;
    }
  }

  getTitleText = () => {
    const { selectedAction, selectedGiftcard } = this.state;

    if (selectedAction === null)
      return giftcardText;
    else if (selectedAction === 'create')
      return createGiftcardText;
    else if (selectedAction === 'find' && !selectedGiftcard.selected)
      return findGiftcardText;
    else if (selectedAction === 'find' && selectedGiftcard.selected)
      return giftcardText;
  }

  getHeight = () => {
    const { selectedAction, selectedGiftcard } = this.state;

    if (selectedAction === null)
      return 200;
    else if (selectedAction === 'create')
      return 300;
    else if (selectedAction === 'find' && selectedGiftcard.selected)
      return 500;
    else if (selectedAction === 'find' && !selectedGiftcard.selected)
      return 400;
  }

  animateClose = () => {
    this.setState({
      shouldClose: true
    }, () => {
      setTimeout(() => {
        this.props.closeWindow()
      }, 500)
    })
  }

  getDefaultView = () => {
    const { getLoadingView } = this;
    return getLoadingView(
      <div className="buttonsWrapper">
        <div className="findButton buttonWrapper" onClick={() => this.setState({ selectedAction: 'find' })}>{findText}</div>
        <div className="createButton buttonWrapper"onClick={() => this.setState({ selectedAction: 'create' })}>{createText}</div>
      </div>
    )
  }

  getCreateView = () => {
    const { amount } = this.state;
    const { create } = this;

    return (
      <div className="createForm">
        <div className="inputTitle">{amountText}</div>
        <div className="inputWrapper itemInput">
          <input
            type="number"
            value={amount}
            onChange={(e) => this.setState({ amount: e.target.value })}
          />
        </div>
        <div className="buttonsWrapper flexEnd">
          <div className="buttonWrapper"onClick={() => create() }>{createText}</div>
        </div>
      </div>
    )
  }

  getSearchItems = () => {
    const { search } = this.state;

    var items = [];
    if (search === '')
      items = [];
    else
      items = this.search();

    if (!Array.isArray(items))
      items = [];

    return items.length > 0 && <div className="searchWrapper searchBorder">
        {items.map((item, index) => {
          return (
            <div className={"searchRow smallText" + ((index + 1) === items.length ? " noBorder" : "")} key={index} onClick={() => this.selectGiftcard(item)}>
              <div>{item.reference}</div>
              <div>{'£' + item.remainAmount}</div>
            </div>
          )
        })}
      </div>
  }

  getFieldView = (field, i) => {
    const { selectedGiftcard } = this.state;
    var value = selectedGiftcard.giftcard[field.property]

    if (field.property === 'remainAmount' || field.property === 'initAmount') {
      value = '£' +  selectedGiftcard.giftcard[field.property]
    } else if (field.property === 'isActive') {
      value = selectedGiftcard.giftcard[field.property] ? 'Yes' : 'No'
    }

    return (
      <div key={i} className="amountInputRow">
        <div>{field.title + ':'}</div>
        <div>{value}</div>
      </div>
    )
  }

  getChangeAmountView = () => {
    const { updateAmount, getLoadingView } = this;
    const { changeAmountAction, changeAmount } = this.state;

    if (changeAmountAction === null) {
      return getLoadingView(
        <div className="buttonsWrapper">
          <div className="findButton buttonWrapper" onClick={() => this.setState({ changeAmountAction: 'add' })}>{addText}</div>
          <div className="createButton buttonWrapper" onClick={() => this.setState({ changeAmountAction: 'subtract' })}>{subtractText}</div>
        </div>
      )
    } else {
      const title = changeAmountAction === 'add' ? addText : subtractText;
      return getLoadingView(
        <div className="buttonsWrapper">
          <div className="amountInputWrapper">
            <input
              type="number"
              value={changeAmount}
              onChange={(e) => this.setState({ changeAmount: e.target.value })}
            />
          </div>
          <div className="createButton buttonWrapper" onClick={() => updateAmount()}>{title}</div>
          <div className="createButton buttonWrapper cancelButton" onClick={() => this.setState({ changeAmountAction: null })}>{cancelText}</div>
        </div>
      )
    }
  }

  getFindView = () => {
    const { search, selectedGiftcard } = this.state;
    const { getSearchItems, getFieldView, getChangeAmountView, getLoadingView, changeActivate, download } = this;

    const presentFields = [
      { title: 'Reference', property: 'reference' },
      { title: 'Giftcard Amount', property: 'initAmount' },
      { title: 'Remaining Amount', property: 'remainAmount' },
      { title: 'Is Active', property: 'isActive' }
    ]

    return (
      <div className="findForm">
        {!selectedGiftcard.selected ?
          <div className="searchWindow">
            <div className="inputWrapper">
              <input
                type="text"
                value={search}
                disabled={this.props.requestLoading}
                onChange={(e) => this.setState({ search: e.target.value })}
                placeholder={searchText}
              />
            </div>
            {getSearchItems()}
            <div style={{height: 30}}></div>
          </div> :
          <div className="selectedGiftcard">
            {presentFields.map(getFieldView)}
            <div className="subtitleText">{changeAmountText}</div>
            {getChangeAmountView()}
            <div className="subtitleText">{moreOptionsText}</div>
            {getLoadingView(<div className="buttonsWrapper">
              <div className="findButton buttonWrapper" onClick={() => changeActivate()}>{selectedGiftcard.giftcard.isActive ? deactivateText : activateText}</div>
              <div className="createButton buttonWrapper"onClick={() => download()}>{downloadText}</div>
            </div>)}
          </div>
        }
      </div>
    )
  }

  render() {
    const { selectedAction, shouldClose } = this.state;
    const { getTitleText, animateClose, getHeight, getDefaultView, getCreateView, getFindView, checkForAlert, redirectBack } = this;

    return (
      <div className={"giftcardWindow" + (shouldClose ? ' closeWindow' : '')}>
        <div className="giftcardForm" style={{ height: getHeight() }}>
          <IosCloseCircleOutline onClick={() => animateClose()} className="closeIcon" fontSize="30px" color="#fff" />
          {selectedAction !== null ?
            <IosArrowRoundBack onClick={() => redirectBack()} className="backIcon" fontSize="45px" color="#fff" /> : void(0)
          }
          <div className="titleText">{getTitleText()}</div>
          {selectedAction === 'find' && getFindView()}
          {selectedAction === null && getDefaultView()}
          {selectedAction === 'create' && getCreateView()}
        </div>
        {checkForAlert()}
      </div>
    )
  }
}


const mapStateToProps = ({ giftcards, admin }) => ({
  token: admin.token,
  giftcards: giftcards.data,
  newGiftcardId: giftcards.newGiftcardId,
  requestFailed: giftcards.requestFailed,
  requestLoading: giftcards.requestLoading,
  requestFinished: giftcards.requestFinished,
})

const mapDispatchToProps = dispatch => bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Giftcard)
